import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (window.EB && window.EB.Ballots) {
      window.EB.Ballots.initRowHighlights();
      window.EB.Ballots.initAbstain();
      window.EB.Ballots.selectRowOnClick();
      window.EB.Ballots.initAutoSelectWriteIn();
      window.EB.Ballots.uniquelySelectAbstain();
      window.EB.Ballots.showHiddenEmailInput();
      window.EB.Ballots.showHiddenWriteIns();
    }
  }
}
